import "./styles.css";
const Legal = () => {
return <div className="legal-page">

    <h1 className="legal-title">Hogcloud, Inc. Terms and Conditions</h1>
    <section className="legal-content">
    <h2>Custom Orders &amp; Personalization Policy</h2>

        <p>
        We offer custom products that allow customers to submit their own names, nicknames, or short phrases. Because all custom text is provided directly by the customer, we take care to operate in a compliant and responsible manner.
        </p>

        <p>
        By placing a custom order, you confirm that any text you submit is a personal name, nickname, or phrase that you have the right to use and that it does not infringe on the rights of any third party, including trademarks or name, image, and likeness (NIL) rights.
        </p>

        <p>
        Custom products are intended for personal use only and may not be purchased for resale, commercial distribution, or promotional purposes without prior written approval.
        </p>

        <p>
        We do not sell or advertise products using protected trademarks, team names, logos, or the name, image, or likeness of athletes or other individuals. Any use of protected trademarks or NIL rights is handled only through the appropriate licensing process.
        </p>

        <p>
        To ensure compliance, we may review custom orders and request clarification before production. If a submitted text cannot be confirmed as compliant, we reserve the right to cancel and refund the order.
        </p>

        <p>
        Our goal is to provide a smooth, respectful, and hassle-free experience while ensuring that all custom products are created responsibly.
        </p>

    
    </section>
    <section className="legal-content">
        <h2>Pendant Safety Notice</h2>

            <p>
            Our pendants are intended for decorative and personal wear use only. Please review the following safety information before use.
            </p>

            <ul>
            <li>
                <strong>Not for children:</strong> Pendants may contain small parts and are not suitable for children under 12 years of age. Choking hazard.
            </li>
            <li>
                <strong>Personal wear only:</strong> This item is not a toy and should not be chewed, swallowed, or used in a manner inconsistent with normal jewelry wear.
            </li>
            <li>
                <strong>Avoid strenuous activity:</strong> Remove the pendant before sleeping, exercising, swimming, or engaging in physical activity to prevent injury or damage.
            </li>
            <li>
                <strong>Skin sensitivity:</strong> If you experience skin irritation or discomfort, discontinue use immediately.
            </li>
            <li>
                <strong>Magnets (if applicable):</strong> Some pendants may contain magnets. Keep magnets away from children and from individuals with pacemakers or other implanted medical devices.
            </li>
            <li>
                <strong>Inspect before use:</strong> Discontinue use if the pendant, chain, or clasp becomes damaged.
            </li>
            </ul>

            <p>
            By purchasing and wearing this product, you acknowledge and accept responsibility for its proper and safe use.
            </p>
    </section>
    <section className="legal-content">
        <h2>Privacy Policy</h2>
        <a href="/privacy">Click here to view our Privacy Policy</a>
    </section>
    <section className="legal-content">
    <h2>PLA Material Information</h2>

        <p>
        Some of our products are manufactured using PLA (polylactic acid), a plant-based plastic commonly used in 3D printing. PLA is lightweight, durable for decorative use, and widely used for custom and handcrafted items.
        </p>

        <ul>
        <li>
            <strong>Material composition:</strong> PLA is derived from renewable resources such as corn starch or sugarcane and is designed for decorative and personal-use products.
        </li>
        <li>
            <strong>Heat sensitivity:</strong> PLA can soften, warp, or melt when exposed to high temperatures. Avoid leaving PLA products in hot vehicles, direct sunlight, or near heat sources.
        </li>
        <li>
            <strong>Not food-safe:</strong> PLA products are not intended for food or beverage use and should not be chewed, swallowed, or consumed.
        </li>
        <li>
            <strong>Intended use:</strong> PLA products should be used only as designed and are not suitable for structural, load-bearing, or safety-critical applications.
        </li>
        </ul>

        <p>
        If you have questions about the materials used in a specific product, please feel free to contact us before purchase.
        </p>

    </section>


</div>
};

export default Legal;